import io from "socket.io-client";
import { END_POINT_SOCKET } from "../constants/defaultValues";

const getAccessToken = () => {
  if (typeof window === "undefined" || !window.localStorage) return null;
  const token = window.localStorage.getItem("access_token");
  if (!token || token === "null" || token === "undefined") return null;
  return token;
};

const mergeAuth = (baseAuth, extraAuth) => ({
  ...(baseAuth || {}),
  ...(extraAuth || {}),
});

export const createSocketOptions = (options = {}) => {
  const token = getAccessToken();
  const auth = mergeAuth(options.auth, token ? { token: `Bearer ${token}` } : {});
  return {
    ...options,
    auth,
  };
};

const createSocket = (options = {}) => io(END_POINT_SOCKET, createSocketOptions(options));

export default createSocket;
